import { gql } from "@apollo/client"
import { useQuery } from "@oysterhr/core"
import { BenefitsPlanCollection } from "@oysterhr/schema"

const QUERY = gql`
  query BenefitPlansStaffPageBenefitPlans {
    benefitPlans {
      collection {
        id
        name
        category
        coverageTypes
        countries
        currencies {
          code
        }
        provider {
          name
        }
        prices {
          id
          startAge
          endAge
          currencies {
            currencyCode
            subunit
            subunitToUnit
          }
          isDefault
        }
      }
    }
  }
`

export const usePlansListOverview = () => {
  return useQuery<{ benefitPlans: BenefitsPlanCollection }>(QUERY)
}
